import React, { useEffect } from 'react';
import Navbar from '../components/navbar';
import { useTranslation } from 'react-i18next';
import SimpleFooter from '../components/simpleFooter';
import { HashLink as Link } from 'react-router-hash-link';
import ReactGA from 'react-ga';

const BlogDetails = ( props ) => {

	const { blogId = 0 } = props.location.state;

	const { t } = useTranslation();

	useEffect(() => {
		window.scrollTo(0, 0);

		//activate menu
		let menuNode = document.querySelector('a.use-cases')
		if(menuNode) {
			menuNode.classList.add('active')
		}

		//remove active class from menu
		let blogNavs = document.querySelectorAll(`a.blog-nav-item.active`)
		if(blogNavs.length > 0){
			for(let link of blogNavs){
				link.classList.remove('active')
			}	
		}

		let blogMenuNode = document.querySelector(`a.blog-link-${blogId}`)
		if(blogMenuNode) {
			blogMenuNode.classList.add('active')
		}
	})

	const blogTitle = t(`blog title ${blogId}`)
	const blogText = t(`blog text ${blogId}`)
	const blogImgUrl = t(`blog image ${blogId}`)

	ReactGA.event({
		category: 'Use cases',
		label: blogTitle,
		action: 'Opened use case',
		value: blogId
	  });

  	return (
  		<div>
	  		<Navbar preUrl={process.env.PUBLIC_URL+'/'} />
	  		<div className="page-margin">

			    <div className="breadcrumb-bg">
			        <div className="container">
			            <div className="row">
			                <div className="col-md-6 col-sm-6 col-text-center d-align-center">
			                    <h2 className="title">{blogTitle}</h2>
			                </div>
			                <div className="col-md-6 col-sm-6 col-text-center">
			                    <nav aria-label="breadcrumb" className="blog-bradcrumb ">
			                        <ol className="breadcrumb bg-transparent mb-0">
			                            <li className="breadcrumb-item"><Link to="/#home">{t('home')}</Link></li>
										<li className="breadcrumb-item"><Link to="/blog-list">{t('use cases')}</Link></li>
			                            <li className="breadcrumb-item active"><a href={null}>{blogTitle}</a></li>
			                        </ol>
			                    </nav>
			                </div>
			            </div>
			        </div>
			    </div>

			    <section>
			        <div className="container">
			            <div className="row">
			                <div className="col-sm-12">
			                    <div className="blog-item">
			                        <div className="blog-block">
			                            <div className="blog-box">
			                                <div className="overflow-hidden">
			                                    <a href={null}>
			                                        <img src={blogImgUrl} alt="blog" className="img-fluid" />
			                                    </a>
			                                </div>
			                            </div>
			                        </div>
			                        <div className="blog-text">
			                            <a href={null}>
			                                <h3 className="blog-head">{blogTitle}</h3>
			                            </a>
			                            <div className="blog-divider"></div>
			                            <div className="blog-description">
											<p>{blogText}</p>
			                                <h5>Ourmind</h5>
			                            </div>
			                        </div>
			                    </div>
			                    <div className="blog-divider"></div>
			                       
			                </div>
			            </div>
			        </div>
			    </section>

				{/*Footer Section start*/}
				<SimpleFooter />
				{/*Footer Section End*/}

			</div>
		</div>
  	);
  }

export default BlogDetails;


// WEBPACK FOOTER //
// ./src/blog/blog-details.js